import React, { Component } from "react";
import OwlCrousel from "../../components/shared/OwlCrousel";

class Rail extends Component {
  state = {
    options: {
      margin: 15,
      rewind: false,
      autoplay: false,  
      dots: false, 
      loop: false,
      responsive: { 
        0: {
          items: 1,
          nav: false,
          slideBy: 1
        },
        480: {
          items: 1,
          nav: false,
          slideBy: 1
        },
        768: {
          items: 2,
          nav: false,
          slideBy: 2
        },
        1000: {
          items: 2,
          nav: true,
          slideBy: 2
        }
      }
    }
  };

  componentDidMount() { }

  componentWillUnmount() { }

  epgStructure(epgStructure) {
    let options;
    if (this.props.startPosition != null) {
      options = {
        ...this.state.options,
        startPosition: parseInt(this.props.startPosition)
      };
    }
    return epgStructure.map((value, index) => {
        let returnHtml =
          value.data && value.data.length > 0 ? (
            <li key={"epg" + index} className={value.class == "" ? "d-none" : ""}>
              <OwlCrousel
                crouselOption={options}
                railType="epg"
                data={value.data}
                showLive={this.props.showLive}
                dataType={index == 0 ? "today" : "tomorrow"}
                showSchedule={this.props.showSchedule}
              />
            </li>
          ) : (
            <li
              key={"epg" + index}
              className={value.class == "" ? "d-none" : "text-center"}
            >
              No Data Exist
            </li>
          );
        return returnHtml;
    });
  }

  render = () => (
    <React.Fragment>
      <div className="col-md-12 no-gutter-col">
        <div className="tabs pad15">
          <ul>
            <li
              className={this.props.data[0].class}
              onClick={this.props.funToday}
            >
              Today
            </li>
            <li
              className={this.props.data[1].class}
              onClick={this.props.funTomorrow}
            >
              Tomorrow
            </li>
          </ul>
        </div>
      </div>
      <div className="col-md-12">
        <div className="tabContent epgContent">
          <ul>{this.epgStructure(this.props.data)}</ul>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Rail;
